import type React from 'react';
import type { ReactNode } from 'react';

const ENTER = 13;
const SPACE = 32;

type TabProps = {
  children?: ReactNode;
  isActive?: boolean;
  isDisabled?: boolean;
  onClick?: (e: React.MouseEvent | React.KeyboardEvent) => void;
  onSelect?: (e: React.MouseEvent | React.KeyboardEvent) => void;
};

const Tab = ({
  children,
  isActive = false,
  isDisabled = false,
  onClick,
  onSelect,
  ...rest
}: TabProps) => {
  const handleClick = (e: React.MouseEvent | React.KeyboardEvent) => {
    if (isDisabled) {
      e.preventDefault();
    }

    onSelect?.(e);
    onClick?.(e);
  };

  return (
    <div
      className={
        isDisabled
          ? 'Tab-link is-disabled'
          : isActive
            ? 'Tab-link is-active'
            : 'Tab-link'
      }
      aria-disabled={isDisabled}
      aria-selected={isActive}
      onClick={handleClick}
      onKeyDown={evt =>
        [ENTER, SPACE].includes(evt.keyCode) && handleClick(evt)
      }
      role="tab"
      tabIndex={0}
      {...rest}
    >
      {children}
    </div>
  );
};

export { Tab };
